<template>
  <div>
    <f-data-table v-bind="fdt_config">
      <template #_actions="props">
        <button class="btn btn-ss-standout" @click="() => toggleCreateEditModal()">
          <i class="flaticon2-plus" />New Notification
        </button>
        <button type="button" class="btn btn-ss btn-icon-sm" @click="props.reloadData">
          <i class="flaticon2-refresh" />Reload Data
        </button>
      </template>
      <template #published="props">
        <span :class="props.value === 0 ? 'text-danger' : 'text-success'">{{ props.value === 0 ? 'No' : 'Yes' }}</span>
      </template>
      <template #created_at="props">
        <span>{{ formatDateTime(props.value) }}</span>
      </template>
      <template #updated_at="props">
        <span>{{ formatDateTime(props.value) }}</span>
      </template>
      <template #actions="props">
        <button type="button" class="btn btn-ss btn-icon">
          <i class="la la-edit" @click="() => toggleCreateEditModal(props.row)" />
        </button>
        <button type="button" class="btn btn-ss-danger btn-icon" @click="props.do({ cb: deleteNotification })">
          <i class="la la-trash" />
        </button>
      </template>
    </f-data-table>
    <dashboard-notification-modal :loaded-notification="loaded_notif" />
  </div>
</template>

<script>
import DashboardNotificationModal from 'VueModals/DashboardNotificationModal';
import FDataTable from "VuePartials/App/Storage/FDataTable/FDataTable.vue";

export default {
  components: {
    DashboardNotificationModal,
    FDataTable,
  },
  data: () => ({
    loaded_notif: null,
    create_modal_name: 'dashboard-notifications-modal',
    fdt_config: {
      id: 'notifications-table',
      dataUri: '/api/v1/admin/dashboard-notifications',
      heading: 'Notifications',
      icon: 'la la-bell',
      locked: true,
      serverSide: true,
      preFilter: [
        {
          field: 'publish_at',
          op: 'gt',
          value: moment(Date.now()).toISOString(),
          type: 'scalar',
        },
      ],
      columns: [
        {
          field: 'name',
          display: 'Name',
          clip_resistance: 1,
        },
        {
          field: 'publish_at',
          display: 'Publish At',
          sort: 'desc',
          active_sort: true,
          toggleable: true,
        },
        {
          field: 'published',
          display: 'Published',
          toggleable: true,
        },
        {
          field: 'created_at',
          display: 'Created At',
          toggleable: true,
        },
        {
          field: 'updated_at',
          display: 'Updated At',
          toggleable: true,
        },
        {
          field: 'actions',
          display: 'Actions',
          never_clip: true,
          sortable: false,
        },
      ],
    },
  }),
  methods: {
    async deleteNotification(notification) {
      try {
        const response = await axios.delete(`/api/v1/admin/dashboard-notifications/${notification.id}`);
        if (response.data.data) {
          toastr.success(response.data.data.message);
        }
      } catch (err) {
        window.handleAxiosError(err);
      }
    },
    /**
     * Toggles the edit modal, which will be filled with data from `this.loaded_notif`
     * if `notification` is supplied; otherwise its a new notif so defaults are used.
     */
    async toggleCreateEditModal(notification) {
      this.loaded_notif = notification; // can be undef, which means we're creating
      const res = await this.fireModal(this.create_modal_name);
      if (res.data.confirm) {
        EventBus.$emit('notifications-table-reload');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.kt-divider {
  font-size: 16px;
  margin: 2em 0;
}
</style>
